import { TextInput } from "@carbon/react";
import get from "lodash.get";
import {
  Control,
  Controller,
  FieldPath,
  FieldValues,
  UseControllerProps,
  useFormState,
} from "react-hook-form";

export type TextInputFormFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = {
  id: string;
  label: string;
  type?: string;
  helperText?: string;
  placeholder?: string;
  control: Control<TFieldValues>;
  ["aria-label"]?: string;
  name: TName;
} & Pick<UseControllerProps<TFieldValues, TName>, "rules">;

export function TextInputFormField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  id,
  name,
  type,
  label,
  placeholder,
  control,
  helperText,
  "aria-label": ariaLabel,
  rules,
}: TextInputFormFieldProps<TFieldValues, TName>) {
  const { errors } = useFormState({ control });
  const error = get(errors, name);

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <TextInput
          id={id}
          labelText={label}
          type={type}
          placeholder={placeholder}
          invalidText={typeof error?.message === "string" ? error.message : null}
          invalid={!!error?.message}
          helperText={helperText}
          aria-label={ariaLabel}
          {...field}
        />
      )}
    />
  );
}
